import { gql } from '@/__generated__';

export const GET_IMAGE_VERSIONS = gql(`#graphql
  query GetImageVersions {
    hardwareImageVersions 
  }
`);
